import { ReactNode } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { getTrans } from 'modules/i18n';

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  onSave: () => void;
  saving: boolean;
  children: ReactNode;
  dataTestId?: string;
}

/** Full-screen editor dialog shell: close, title, save. */
export const EditorDialog = ({
  open,
  title,
  onClose,
  onSave,
  saving,
  children,
  dataTestId = 'editor-dialog'
}: Props) => (
  <Dialog open={open} onClose={onClose} fullScreen data-testid={dataTestId}>
    <AppBar position="sticky" color="default" elevation={0}>
      <Toolbar>
        <IconButton
          edge="start"
          onClick={onClose}
          aria-label={getTrans('general.close')}
          data-testid={`${dataTestId}-close`}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" sx={{ flexGrow: 1, ml: 1 }}>
          {title}
        </Typography>
        <Button
          onClick={onSave}
          disabled={saving}
          variant="contained"
          data-testid={`${dataTestId}-save`}
        >
          {getTrans('general.save')}
        </Button>
      </Toolbar>
    </AppBar>
    <DialogContent sx={{ pb: 6 }}>{children}</DialogContent>
  </Dialog>
);
